<template>
  <VApp>
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            md4
            sm8
            xs12
          >
            <PhoneVerificationCheckCard />
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import PhoneVerificationCheckCard from '@/components/PhoneVerificationCheckCard'
export default {
  name: 'PhoneVerificationCheckPage',
  components: {
    PhoneVerificationCheckCard
  }
}
</script>

<style scoped>

</style>
